import { render, staticRenderFns } from "./BookHouse.vue?vue&type=template&id=4c13c8a6&scoped=true&"
import script from "./BookHouse.vue?vue&type=script&lang=js&"
export * from "./BookHouse.vue?vue&type=script&lang=js&"
import style0 from "./BookHouse.vue?vue&type=style&index=0&id=4c13c8a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c13c8a6",
  null
  
)

export default component.exports